export default __webpack_public_path__ + "static/media/BGF2024_bg2_mobile.0b8d0515.webp";